import { Role } from "@/roles/entities/Role"
import { Auth } from "../services/Auth"

/**
 * Para verificar que el profesor que accede a la ruta concuerda con el parametro del profesor de la ruta.
 * Por ejemplo, si el docente tiene el id 4 y accede a https://localhost:3000//.../profesores/5/.. no lo dejará acceder
 */
const personParamPolicy = (to) => {

    const user = Auth.user()
    const person = Auth.person()

    // Solo administradores y consejo pueden ver la información de otros docentes
    if (user.hasRole(Role.ADMINISTRATOR_NAME) || user.hasRole(Role.COUNCIL_NAME)) {
        return true
    }

    if (to.params.personId != person.id) {
        return false
    }

    return true

}

const postDegreePolicy = () => {
    const user = Auth.user()
    if (user.hasRole(Role.POSTGRADE_NAME)) {
        return true
    }
    return false
}

const councilParamPolicy = () => {
    const user = Auth.user()
    if (user.hasRole(Role.COUNCIL_NAME)) {
        return true
    }
    return false
}

const adminParamPolicy = () => {
    const user = Auth.user()
    if (user.hasRole(Role.ADMINISTRATOR_NAME)) {
        return true
    }
    return false
}

let policies = {
    'persons.addresses': personParamPolicy,
    'persons.academic-activities': personParamPolicy,
    'persons.activities': personParamPolicy,
    'persons.activities.other': personParamPolicy,
    'persons.appointments': personParamPolicy,
    'persons.associations': personParamPolicy,
    'persons.awards': personParamPolicy,
    'persons.academic-arbitrations': personParamPolicy,
    'persons.administrative-positions': personParamPolicy,
    'persons.reports': personParamPolicy,
    'persons.research-arbitrations': personParamPolicy,
    'persons.articles': [personParamPolicy, postDegreePolicy],
    'persons.broadcasts': personParamPolicy,
    'persons.conferences': personParamPolicy,
    'persons.committes.collegiate.list': personParamPolicy,
    'persons.committes.advisers.list': personParamPolicy,
    'persons.commissions.advisers.list': personParamPolicy,
    'persons.commissions.evaluators.list': personParamPolicy,
    'persons.commissions.list': personParamPolicy,
    'persons.committes.list': personParamPolicy,
    'persons.comparative': personParamPolicy,
    'persons.courses': personParamPolicy,
    'persons.courses.postgraduate': personParamPolicy,
    'persons.courses.external': personParamPolicy,
    'persons.courses.extracurriculars': personParamPolicy,
    'persons.creations': [personParamPolicy, postDegreePolicy],
    'persons.entrance-and-location': personParamPolicy,
    'persons.employments': personParamPolicy,
    'persons.events.works': personParamPolicy,
    'persons.education': personParamPolicy,
    'persons.guidance.professors': personParamPolicy,
    'persons.guidance.students': personParamPolicy,
    'persons.juries': personParamPolicy,
    'persons.languages': personParamPolicy,
    'persons.materials': personParamPolicy,
    'persons.personal-information': personParamPolicy,
    'persons.products': [personParamPolicy, postDegreePolicy],
    'persons.patents': [personParamPolicy, postDegreePolicy],
    'persons.projects.unam': personParamPolicy,
    'persons.publications': personParamPolicy,
    'persons.resume': personParamPolicy,
    'persons.reviews': personParamPolicy,
    'persons.social-services': personParamPolicy,
    'persons.services': personParamPolicy,
    'persons.supports': personParamPolicy,
    'persons.tutorings': personParamPolicy,
    'persons.technology-developments': [personParamPolicy, postDegreePolicy],
    'persons.thesis': personParamPolicy,
    'persons.trainings': [personParamPolicy, postDegreePolicy],
    'persons.tutorings.postgraduate': personParamPolicy,
    'persons.faculty-programs': personParamPolicy,
    'persons.fairs': personParamPolicy,
    'persons.external-programs': personParamPolicy,
    'persons.presentations': personParamPolicy,

    'professors.list': [adminParamPolicy, postDegreePolicy, councilParamPolicy],

    'programs.import': adminParamPolicy,
    'degrees.import': adminParamPolicy,
    'projects.import': adminParamPolicy,
    'tutorings.import': adminParamPolicy,
    'juries.import': adminParamPolicy,
    'courses.import': adminParamPolicy,
}

export const verifyPoliciesMiddleware = (to, from, next) => {

    let policiesFound = policies[to.name]

    if (!policiesFound) {
        return next();
    }

    if (!Array.isArray(policiesFound)) {
        policiesFound = [policiesFound]
    }

    for (const policy of policiesFound) {
        if (policy(to, from, next)) {
            return next();
        }
    }

    // TODO: Enviar a la pagina 403
    return next({ name: 'login' });
}